import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const ViewToggle: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const is3DView = location.pathname === '/3d';
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768); // Tailwind's md breakpoint
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const toggleView = () => {
    if (isMobile) {
      // On mobile, refresh the page completely to ensure proper loading
      if (is3DView) {
        window.location.href = '/';
      } else {
        window.location.href = '/3d';
      }
    } else {
      // On desktop, use normal navigation
      if (is3DView) {
        navigate('/');
      } else {
        navigate('/3d');
      }
    }
  };

  // Don't render the toggle button on mobile
  if (isMobile) {
    return null;
  }

  return (
    <button
      onClick={toggleView}
      className="fixed bottom-[40px] right-[40px] p-4 rounded-full bg-[#0048FF] hover:bg-[#0038CC] transition-all duration-300 z-[10000] shadow-lg"
      aria-label="Toggle view"
    >
      {is3DView ? (
        // List icon (2 horizontal lines)
        <div className="w-4 h-4 flex flex-col justify-center items-center">
          <div className="w-full h-0.5 bg-white mb-1"></div>
          <div className="w-full h-0.5 bg-white"></div>
        </div>
      ) : (
        // Circle icon for 3D view
        <div className="w-4 h-4 flex items-center justify-center">
          <div className="w-4 h-4 border border-white border-2 rounded-full"></div>
        </div>
      )}
    </button>
  );
};
